import React from 'react';
import PropTypes from 'prop-types';
import ProductImage from '@/kenwood/components/atoms/ProductImage';

const CompareTrayProducts = ({ products, onPopProduct }) => {
  const handleRemoveProduct = ({ code, materialGroup }) => {
    onPopProduct({ productCode: code, materialGroup });
  };
  return (
    <section className='ken-compare__tray__bottom__products'>
      {[0, 1, 2].map(item => {
        const product = products[item];
        if (!product) return <section key={item} className='--product' />;
        return (
          <section key={item} className='--product --fill'>
            <button
              type='button'
              className='ken-icon ken-icon--close'
              onClick={() => handleRemoveProduct(product)}
            />
            <section className='--product-content'>
              <section className='--product-image'>
                <ProductImage product={product} imgFormat='compareCollapsed' />
              </section>
              <section className='--product-info'>
                <span className='--product-name'>{product.name}</span>
                <span className='--product-code'>{product.code}</span>
              </section>
            </section>
          </section>
        );
      })}
    </section>
  );
};

CompareTrayProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onPopProduct: PropTypes.func,
};

CompareTrayProducts.defaultProps = {
  onPopProduct: null,
};

export default CompareTrayProducts;
